import { Component, OnInit } from '@angular/core';
import { getUrlParams } from 'src/app/shared';
import { AbsenceService, EncryptionService, IncidentalAbsence } from '../..';
import { IncidentalAbsenceDialogParams } from '../../models/indicental-absence-dialog-params';

@Component({
    selector: 'app-absence-page',
    template: `
    <app-section>
      <app-absence-summary
        class="tw-w-full"
        [absences]="absences"
        [absencesLoading]="absencesLoading"
        [sentenceCase]="false"
        title="Absences for {{ incidentalAbsenceDialogParams.empName | titlecase }} - {{ incidentalAbsenceDialogParams.empId }}"
        [incidentalAbsenceDialogParams]="incidentalAbsenceDialogParams"
      ></app-absence-summary>
    </app-section>
  `,
    styles: [],
    standalone: false
})
export class AbsencePageComponent implements OnInit {
  absences: IncidentalAbsence[] = [];

  incidentalAbsenceDialogParams: IncidentalAbsenceDialogParams;

  absencesLoading: boolean = true;

  constructor(
    private absenceService: AbsenceService,
    private encrypt: EncryptionService
  ) {}

  async ngOnInit() {
    const params = getUrlParams();
    if (params.value) {
      const value = JSON.parse(this.encrypt.decrypt(params.value));
      this.incidentalAbsenceDialogParams = new IncidentalAbsenceDialogParams();
      this.incidentalAbsenceDialogParams.empName = value.empName;
      this.incidentalAbsenceDialogParams.empId = value.empId;
      this.incidentalAbsenceDialogParams.hrMasterUid = value.hrMasterUid;
      this.incidentalAbsenceDialogParams.empUnum = value.empUnum;
      this.incidentalAbsenceDialogParams.encryptedEmployeeId = value.encryptedEmployeeId;
      const listAbsenceOffWork = await this.absenceService.getEmployeeAbsences(
        value.empUnum
      );
      this.absences = this.absenceService.mergeDateToString(listAbsenceOffWork);
      this.absencesLoading = false;
    }
  }
}
